import React from 'react';

import { SkeletonContainer } from 'src/app/pages/starterDashboardV2/shared/components';

import type { Platform } from '../../../../shared/constants';
import { PlatformIcon } from '../../../common/PlatformIcon';

type Props = Readonly<{
	platform?: Platform;
}>;

export const ReadyToSharePostsCardLoading: React.FC<Props> = ({ platform = 'facebook' }) => {
	return (
		<SkeletonContainer loading>
			<div
				data-platform={platform}
				data-testid={`placeholder-ready-to-share-${platform}`}
				className="relative h-[188px] w-[147px] flex-shrink-0"
				aria-hidden="true"
			>
				<div className="relative h-full rounded-b-lg rounded-t-xl bg-white">
					<div className="h-3 animate-pulse rounded-t-xl bg-icon-inverse-disabled px-2.5 pt-1.5">
						<div className="flex gap-1.5">
							{/* Tab indicators */}
							<div className="h-px w-8 bg-white" />
							<div className="h-px w-8 bg-white" />
							<div className="h-px w-8 bg-white opacity-50" />
						</div>
					</div>

					<div className="flex animate-pulse items-center gap-1 bg-icon-inverse-disabled px-2 pb-1">
						<div className="h-3 w-3 rounded-full bg-white" />
						<div className="h-1 w-14 rounded-full bg-white" />
					</div>

					{/* Image preview area */}
					<div className="relative mx-2 mt-2 h-[105px] animate-pulse bg-icon-inverse-disabled">
						<div className="absolute bottom-0 left-0 space-y-1">
							<div className="h-3 w-[75px] bg-white" />
							<div className="h-3 w-24 bg-white" />
							<div className="h-3 w-24 bg-white" />
						</div>
					</div>

					<div className="flex animate-pulse items-center gap-1 px-2 pt-2">
						<div className="h-2.5 w-2.5 rounded-[2px] bg-icon-inverse-disabled" />
						<div className="h-1 w-14 rounded-full bg-icon-inverse-disabled" />
					</div>
				</div>

				{/* Platform badge */}
				<PlatformIcon platform={platform} />
			</div>
		</SkeletonContainer>
	);
};
